var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"product-btn-row"},[_c('a',{staticClass:"btn btn-orange btn-block",attrs:{"role":"button","disabled":_vm.status.isWorking || !_vm.productId},on:{"click":_vm.onClick}},[_vm._v("\n    "+_vm._s(_vm.status.isWorking ? _vm.$t("Adding to cart...") : _vm.$t("Add to cart"))+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }